import { Component, OnInit } from '@angular/core';
import { AuthService } from '@argalis-apps/angular-core';

@Component({
  selector: 'app-argalis-apps-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  constructor(private authService: AuthService) {}

  async ngOnInit() {
    await this.authService.resignin(); // gère la reconnexion
  }
}
